module.exports = __webpack_public_path__ + "static/img/footantsey.006bf97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/testimonial-logos/footantsey.png
// module id = WWK1
// module chunks = 0